package com.tovtalk.utils

import kotlinx.browser.window

/**
 * Returns the visible viewport height in pixels.
 * Prefers [visualViewport.height] (accounts for mobile address bar, keyboard) with fallback to [window.innerHeight].
 * Use this instead of innerHeight for layout/positioning on mobile Web.
 */
fun viewportHeightPx(): Int {
    val vv = window.asDynamic().visualViewport
    return if (vv != null && (vv.height as Double) > 0) {
        (vv.height as Double).toInt()
    } else {
        (window.asDynamic().innerHeight as Double).toInt()
    }
}

/**
 * Returns the visible viewport width in pixels.
 * Prefers [visualViewport.width] with fallback to [window.innerWidth].
 */
fun viewportWidthPx(): Int {
    val vv = window.asDynamic().visualViewport
    return if (vv != null && (vv.width as Double) > 0) {
        (vv.width as Double).toInt()
    } else {
        (window.asDynamic().innerWidth as Double).toInt()
    }
}
